module.exports = __webpack_public_path__ + "ls.75282372.svg";